// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/search-check.js';

import { paths } from '../generated/search-check';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('search-check', Original, paths);
